import base from '@/http/url_base';

export default {
  SESSION_PARTICIPATION: base.API_RH + '/session-participations',
  GET_REQUIREMENTS: base.API_RH + '/session-participations/requirements',

  ACCEPTER: base.API_RH + '/session-participations/accepter',
  REFUSER: base.API_RH + '/session-participations/refuser',
  REINITIALISER: base.API_RH + '/session-participations/reinitialiser',
};
